import countryList from 'react-select-country-list';
import { BillingAction, BillingActionType } from '../actionTypes/billing';
import { IBillingDashboardData, IMonthlyCosts } from '../types';

const INIT_BILLING_STATE = {
    currentMonthCosts: {
        admins: {
            numberOfAdmins: 0,
            pricePerUnit: 0,
        },
        students: {
            numberOfStudents: 0,
            pricePerUnit: 0,
        },
        supervisors: {
            numberOfExternalSupervisors: 0,
            numberOfInternalSupervisors: 0,
            pricePerUnit: 0,
        },
    },
    nextMonthCostsPrediction: {
        admins: {
            numberOfAdmins: 0,
            pricePerUnit: 0,
        },
        students: {
            numberOfStudents: 0,
            pricePerUnit: 0,
        },
        supervisors: {
            numberOfExternalSupervisors: 0,
            numberOfInternalSupervisors: 0,
            pricePerUnit: 0,
        },
    },
    billingDetails: null,
    cardDetails: null,
    invoices: [],
};

const billingReducer = (
    state: IBillingDashboardData = INIT_BILLING_STATE,
    action: BillingAction
) => {
    let country: { label: string; value: string } | null;
    let newState: IBillingDashboardData;
    switch (action.type) {
        case BillingActionType.GET_BILLING_DASHBOARD_DATA:
            country = parseCountyData(action.payload.billingDetails?.country);
            newState = {
                billingDetails: null,
                cardDetails: action.payload.cardDetails ?? null,
                currentMonthCosts: action.payload
                    .currentMonthCosts as IMonthlyCosts,
                nextMonthCostsPrediction: action.payload
                    .nextMonthCostsPrediction as IMonthlyCosts,
                invoices: action.payload.invoices ?? [],
            };
            if (action.payload.billingDetails) {
                newState.billingDetails = {
                    ...action.payload.billingDetails,
                    country,
                };
            }

            return newState;
        case BillingActionType.ADD_CARD_TO_CUSTOMER: {
            const newState = {
                ...state,
                cardDetails: action.payload.cardDetails,
            };

            return newState as IBillingDashboardData;
        }
        case BillingActionType.CREATE_BILLING_CUSTOMER_DATA: {
            const country = parseCountyData(
                action.payload.billingDetails?.country
            );

            const newState = {
                ...state,
                billingDetails: { ...action.payload.billingDetails, country },
            };

            return newState as IBillingDashboardData;
        }
        default:
            return state;
    }
};

const parseCountyData = (country?: string | null) => {
    if (!country) {
        return null;
    }

    return {
        label: countryList().getLabel(country),
        value: country,
    };
};

export default billingReducer;
